/**
 * Switches query params to a new stat group, preserving user context
 * (queryType, year range, teams, biographicalFilters) while resetting
 * group-specific state (selectedStats, statisticalFilters, sortBy, sortDirection)
 * to the catalog's landing defaults for that group.
 */
export function applyGroupChange(params, groupId, catalog) {
  if (groupId === params.groupId) {
    return cloneParams(params);
  }

  const landing =
    catalog.landingByGroup[groupId] ||
    catalog.landingByGroup[catalog.defaultGroupId];

  return {
    ...landing,
    groupId,
    selectedStats: [...(landing.selectedStats || [])],
    statisticalFilters: cloneStatisticalFilters(landing.statisticalFilters),
    sortBy: landing.sortBy,
    sortDirection: landing.sortDirection,
    queryType: params.queryType,
    startYear: params.startYear,
    endYear: params.endYear,
    teams: [...(params.teams || [])],
    biographicalFilters: { ...(params.biographicalFilters || {}) },
  };
}

function cloneParams(params) {
  return {
    ...params,
    selectedStats: [...(params.selectedStats || [])],
    statisticalFilters: cloneStatisticalFilters(params.statisticalFilters),
    biographicalFilters: { ...(params.biographicalFilters || {}) },
    teams: [...(params.teams || [])],
  };
}

function cloneStatisticalFilters(statisticalFilters = {}) {
  return Object.fromEntries(
    Object.entries(statisticalFilters).map(([k, v]) => [
      k,
      v && typeof v === "object" ? { ...v } : v,
    ])
  );
}
